import {Notification} from '../navigation/page-layout';
import React, {useEffect, useState} from 'react';
import {AppLayout, SideNavigation} from '@amzn/awsui-components-react';
import {InboundBridgeP2A} from './inbound-bridge-p2a';
import {InboundBridgeP2P} from './inbound-bridge-p2p';

export function ViewInboundBridge(props: {pushNotification: (notification: Notification) => void}) {
    const [currentHash, setCurrentHash] = useState(window.location.hash);

    useEffect(() => {
        const handleHashChange = () => {
            setCurrentHash(window.location.hash);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const renderContent = () => {
        switch (currentHash) {
            case '#/plan-to-actuals':
                return <InboundBridgeP2A pushNotification={props.pushNotification} />;
            case '#/plan-to-plan':
                return <InboundBridgeP2P pushNotification={props.pushNotification} />;
            default:
                return <InboundBridgeP2A pushNotification={props.pushNotification} />;
        }
    };

    return (
        <AppLayout
            content={renderContent()}
            navigation={
                <SideNavigation
                    header={{
                        href: `#`,
                        text: 'Inbound Bridging',
                    }}
                    items={[
                        {
                            type: 'link',
                            text: 'Plan to Actuals',
                            external: false,
                            href: `#/plan-to-actuals`,
                        },
                        {
                            type: 'link',
                            text: 'Plan to Plan',
                            external: false,
                            href: `#/plan-to-plan`,
                        },
                    ]}
                    activeHref={currentHash}
                />
            }
            toolsHide={true}
        />
    );
}

export enum BridgeType {
    P2A = 'p2a',
    P2P = 'p2p',
}

export type InboundBridgeRecord = {
    date: string;
    node: string;
    granularity: Record<string, string>;
    bucketSeqId: number;
    bucketName: string;
    bucketValue: number;
    bucketError: number;
    lastBucketValue: number;
    wapeContribution: string;
};

export type NodeFilterData = {
    node: string;
    balanceDateEarliest: string;
    balanceDateLatest: string;
    balanceDateStart: string;
    balanceDateEnd: string;
    fromHorizonInWeeks: number;
    toHorizonInWeeks: number;
    channels?: string[];
    sourceLocations?: string[];
    ibTypes?: string[];
    tempZones?: string[];
};
